import { CheckCircle2, Edit, Ban, ShieldCheck, Trash2, KeyRound } from "lucide-react";
import { Button } from "@/components/ui/button";

const statusCls = (s) => s === "approved" ? "status-paid" : s === "blocked" ? "bg-red-100 text-red-700" : "status-unpaid";

const CustomerRow = ({ c, onApprove, onToggleBlock, onEdit, onDelete, onSetPassword }) => (
  <div className="grid grid-cols-12 px-4 py-3 border-b border-gray-100 items-center text-sm" data-testid={`admin-customer-${c.id}`}>
    <div className="col-span-3">
      <div className="font-medium">{c.name || "—"}</div>
      <div className="text-xs text-gray-500 truncate">{c.email}</div>
    </div>
    <div className="col-span-2 text-xs">
      {c.mobile || "—"} {c.mobile_verified && <CheckCircle2 className="inline w-3 h-3 text-green-600 ml-1"/>}
    </div>
    <div className="col-span-2 text-xs">{c.is_gst ? <span className="font-mono">{c.gstin}</span> : <span className="text-gray-400">Non-GST</span>}</div>
    <div className="col-span-1 text-center">
      <span className={`status-pill ${statusCls(c.status)}`} data-testid={`customer-status-${c.id}`}>{c.status}</span>
    </div>
    <div className="col-span-1 text-center text-xs">{c.credit_days || 0}d</div>
    <div className="col-span-3 flex justify-end gap-2 items-center">
      {c.status === "pending" && (
        <Button size="sm" onClick={() => onApprove(c)} className="bg-[#0e5a32] hover:bg-[#0a4626] rounded-sm" data-testid={`approve-${c.id}`}>
          Approve
        </Button>
      )}
      <button onClick={() => onToggleBlock(c)} title={c.status === "blocked" ? "Allow login" : "Restrict login"} className={c.status === "blocked" ? "text-green-600 hover:text-green-700" : "text-gray-400 hover:text-amber-600"} data-testid={`block-toggle-${c.id}`}>
        {c.status === "blocked" ? <ShieldCheck className="w-4 h-4" strokeWidth={1.5}/> : <Ban className="w-4 h-4" strokeWidth={1.5}/>}
      </button>
      <button onClick={() => onEdit(c)} title="Edit" className="text-gray-400 hover:text-[#002fa7]" data-testid={`edit-customer-${c.id}`}><Edit className="w-4 h-4" strokeWidth={1.5}/></button>
      <button onClick={() => onSetPassword(c)} title="Set password" className="text-gray-400 hover:text-[#002fa7]" data-testid={`set-password-${c.id}`}><KeyRound className="w-4 h-4" strokeWidth={1.5}/></button>
      <button onClick={() => onDelete(c.id)} title="Delete" className="text-gray-400 hover:text-red-600" data-testid={`delete-customer-${c.id}`}><Trash2 className="w-4 h-4" strokeWidth={1.5}/></button>
    </div>
  </div>
);

export const CustomerTable = ({ customers, onApprove, onToggleBlock, onEdit, onDelete, onSetPassword }) => (
  <div className="border border-gray-200">
    <div className="grid grid-cols-12 px-4 py-3 bg-gray-50 border-b border-gray-200 text-xs uppercase tracking-wider text-gray-600 font-medium">
      <div className="col-span-3">Customer</div>
      <div className="col-span-2">Mobile</div>
      <div className="col-span-2">GST</div>
      <div className="col-span-1 text-center">Status</div>
      <div className="col-span-1 text-center">Credit</div>
      <div className="col-span-3 text-right">Actions</div>
    </div>
    {customers.map((c) => (
      <CustomerRow key={c.id} c={c} onApprove={onApprove} onToggleBlock={onToggleBlock} onEdit={onEdit} onDelete={onDelete} onSetPassword={onSetPassword} />
    ))}
    {customers.length === 0 && <div className="p-8 text-sm text-gray-500">No customers yet.</div>}
  </div>
);
